/* eslint-disable no-extra-boolean-cast */
import { store } from 'app/store';
import ErrorBoundary from 'components/ErrorBoundary';
import { LoadingProvider } from 'components/LoadingComponent/LoadingContext';
import vi from 'date-fns/locale/vi';
import AppContainer from 'layouts/AppContainer';
import React, { useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { initializeApp } from "firebase/app";
import { firebaseConfig } from 'configs/firebase';
import { sourceApp, versionApp } from 'utils/constants';
import { getStorageData, setStorageData, STORAGE_KEY } from 'utils/storage';
import { apiAppSSO } from 'api/request';
import urlApp from 'api/urlApp';
import { toastError } from 'utils/toastify';
import { get, size } from 'lodash';
import { onLogout } from 'utils/common';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import './i18n';

registerLocale('vi', vi);
setDefaultLocale('vi');
const App: React.FC = () => {

  useEffect(() => {
    // Initialize Firebase
    initializeApp(firebaseConfig)
  }, [])

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = urlParams.get('code');
  const username = urlParams.get('username');

  async function getToken(): Promise<void> {
    const payload = {
      username: username || '',
      source: sourceApp,
      token: code || '',
      version: versionApp,
    }

    try {
      // const { data } = await apiAppSSO.get<BaseResponse>(`${urlApp.verifyToken}?source=${payload.source}&token=${payload.token}&username=${payload.username}&version=${payload.version}`)
      const { data } = await apiAppSSO.get<BaseResponse>(`${urlApp.verifyToken}?source=${payload.source}&token=${payload.token}&username=${payload.username}`)
      setStorageData(STORAGE_KEY.ACCESS_TOKEN, data.data.token);
      setStorageData(STORAGE_KEY.USER_INFO, data.data.data);
      window.location.href = window.location.origin
    } catch (error) {
      if (size(get(error, 'response.data.message')) > 0) {
        onLogout()
      }
      toastError(get(error, 'response.data.message', 'Đã xảy ra lỗi'))
    }
  }

  useEffect(() => {
    const token = getStorageData<string>(STORAGE_KEY.ACCESS_TOKEN);
    if (!!code) {
      if (!token) {
        getToken()
      } else {
        window.location.href = window.location.origin
      }
    }
    // getShareCode()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])


  return (
    <ErrorBoundary>
      <Provider store={store}>
        <React.Suspense fallback={null}>
          <BrowserRouter>
            <LoadingProvider>
              <Routes>
                <Route path="/*" element={<AppContainer />} />
              </Routes>
            </LoadingProvider>
          </BrowserRouter>
        </React.Suspense>
      </Provider>
      <ToastContainer autoClose={3000} />
    </ErrorBoundary>
  );
};

export default App;
